<template>
  <li class="normal" style="margin-top: 0.75em;">
    <div :class="editingIdx === commentIdx ? 'selected' : ''">
      <div style="margin: 5px">
        <p class="fl_right btns" v-if="isMine">
          <a
            class="a_type_2"
            @click="setEditingMode(commentIdx, contents)"
            style="margin-right: 5px;"
          >{{ editingIdx !== commentIdx ? '수정' : '취소' }}</a>
          <a class="a_type_2" @click="onDelete">삭제</a>
        </p>
        <p class="cmt-cmt">{{ contents }}</p>
        <p class="info">
          <a class="owner">
            <b>{{ author.username }}</b>님
          </a>
          <a class="date">{{ uploadAt.format('LLL') }} ({{ uploadAt.fromNow() }})</a>
        </p>
      </div>
    </div>
  </li>
</template>
<script>
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
export default {
  name: "BroadcastComment",
  props: [
    "uploadAt",
    "author",
    "contents",
    "isMine",
    "idx",
    "commentIdx",
    "editingIdx",
    "refreshComments",
    "setEditingMode"
  ],
  methods: {
    onDelete() {
      const self = this;
      this.$confirm({
        title: `“${this.contents}”`,
        content: "정말로 해당 메세지를 삭제하시겠습니까?",
        okText: "네, 삭제합니다.",
        okType: "danger",
        cancelText: "아니요",
        onOk() {
          self.onDeleteReq();
        },
        onCancel() {}
      });
    },
    async onDeleteReq() {
      const { data } = await Axios.delete(
        `${config.hostname}/v1/broadcast/uncle/comment/${this.idx}/${this.commentIdx}`,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            await this.refreshComments();
            config.alert.mixin({
              type: "success",
              title: "성공적으로 삭제되었습니다."
            });
            break;
        }
      }
    }
  }
};
</script>
